import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ISchool } from '../../../interfaces/groups/school.interface';
import { IRadioCheckboxConfig } from '../../../interfaces/radio-checkbox-config.interface';
import { SchoolsState } from '../../../store/state/schools.state';
import { BaseComponent } from '../../../abstracts/base.abstract';

@Component({
    selector: 'app-school-selector',
    templateUrl: './school-selector.component.html',
    styleUrls: ['./school-selector.component.scss'],
})
export class SchoolSelectorComponent extends BaseComponent implements OnInit {
    @Select(SchoolsState.getAllSchools) public schools$: Observable<ISchool[]>;
    @Input() public control: FormControl;
    @Input() public readonly = false;

    @Output() public isLoaded = new EventEmitter<boolean>();
    @Output() public elementSizeModification = new EventEmitter<void>();

    public radioConfig: IRadioCheckboxConfig;
    public maxSchoolSelection = 50;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.uns = this.schools$.subscribe((schools: ISchool[]) => {
            this.maxSchoolSelection = schools.length;
            this.radioConfig = {
                formGroupName: 'schools',
                inputType: 'checkbox',
                questionChoices: schools.map((school: ISchool) => ({ value: school.id, label: school.name })),
            };
            this.isLoaded.emit();
        });
    }
}
